<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant="mini"
    class="main-nav"
    color="#223640"
    app
    :elevation="1"
    dark
    :temporary="mobileMenu"
  >
    <v-list-item class="px-1" v-if="!mini">
      <v-list-item-content style="padding:5px; border-radius: 10px;">
        <img
          class="logo"
          src="../assets/side-menu-logo.jpg"
          style="width: 220px; border-radius: 10px;padding:10px;background:white"
        />
      </v-list-item-content>
    </v-list-item>
    <div>
      <v-list dense nav>
        <v-list-item-group color="teal">
          <template v-for="item in menus">
            <v-list-group
              :key="item.title"
              no-action
              v-if="item.subMenus"
              color="teal"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-menu open-on-hover right offset-x dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon dark v-bind="attrs" v-on="on"
                        >{{ item.icon }}
                      </v-icon>
                    </template>

                    <v-list class="pl-5 pr-5" v-if="mini" color="#385F73">
                      <h4>{{ item.title }}</h4>
                      <v-list-item
                        @click="goToPage(subItem.path)"
                        v-for="subItem in item.subMenus"
                        :key="`${item.title}${subItem.title}`"
                        link
                      >
                        <v-list-item-content>
                          <h5>{{ subItem.title }}</h5>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon v-if="subItem.icon"
                            >{{ subItem.icon }} mdi-18px</v-icon
                          >
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="goToPage(subItem.path)"
                v-for="subItem in item.subMenus"
                :key="`${item.title}${subItem.title}`"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon v-if="subItem.icon"
                    >{{ subItem.icon }} mdi-18px</v-icon
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>

            <v-list-item v-else :key="item.title" @click="goToPage(item.path)">
              <v-list-item-icon>
                <v-tooltip bottom color="#385F73" v-if="mini">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark v-bind="attrs" v-on="on"
                      >{{ item.icon }}
                    </v-icon>
                  </template>

                  {{ item.title }}
                </v-tooltip>
                <span v-else>  <v-icon dark
                      >{{ item.icon }}
                    </v-icon></span>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </div>

    <!-- <v-list-item-content class="sigsenz-logo">
      <h6 style="color: black">Powered By</h6>

      <div style="padding: 2px 20px">
        <a href="https://sigsenz.com/">
          <img
            style="width: 100px"
            src="https://cdn.sigsenz.com/img/sigsenz-logo.png"
            alt="SigSenz"
          />
        </a>
      </div>
    </v-list-item-content> -->
  </v-navigation-drawer>
</template>

<script>
import menuJson from "./menu.json";
import Footer from "@/components/FooterComponent.vue";

export default {
  name: "SideMenu",
  component: {
    Footer,
  },
  data: () => ({
    right: null,
    drawer: true,
    mini: false,
    showMenu: true,
    menus: [],
    menuJsonObj: null,
    cruds: [
      ["Create", "mdi-plus-outline"],
      ["Read", "mdi-file-outline"],
      ["Update", "mdi-update"],
      ["Delete", "mdi-delete"],
    ],
  }),
  watch: {
    "$store.state.user.menu": {
      handler(value) {
        this.showMenu = value;
      },
      deep: true,
    },
    showMenu: {
      deep: true,
      handler(value) {
        let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
        if (!this.mobileMenu && zoom < 100) {
          this.mini = !value;
        } else {
          this.drawer = value;
        }
      },
    },
    drawer: {
      handler(value) {
        if (this.mobileMenu) {
          this.$store.dispatch("showMenu", value);
        } else {
          this.mini = !value;
        }
      },
    },
  },
  mounted() {
    this.menuJsonObj = JSON.parse(JSON.stringify(menuJson));
    this.menus = this.getMenu();
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    currentRouteName() {
      return this.$route.path;
    },

    mobileMenu() {
      return window.screen.width < 800;
    },
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    getMenu() {
      let access = this.$store.state.user.user.access;
      let products = this.$store.state.user.user.products;
      let menus = [];
      if (!this.menuJsonObj) return;
      this.menuJsonObj.forEach((e) => {
        let userAccess = access.find((a) => a.name == e.moduleName);
        let haveAccess =
          access.map((e) => e.name).includes(e.moduleName) &&
          (!e.product || products.includes(e.product));
        let sideMenu = e;
        if (
          (haveAccess &&
          e.subMenus &&
          (userAccess.actions.includes("ALL") ||
            userAccess.actions.includes("search"))) || (e.subMenus && !e.moduleName)
        ) {
          let submenu = [];
          e.subMenus.forEach((f) => {
            if (
              access.map((k) => k.name).includes(f.moduleName) &&
              (!f.product || products.includes(f.product))
            ) {
              submenu.push(f);
            }
          });

          sideMenu.subMenus = submenu.slice();
          menus.push(sideMenu);
        } else if (
          haveAccess &&
          (userAccess.actions.includes("ALL") ||
            userAccess.actions.includes("create"))
        ) {
          menus.push(sideMenu);
        }
      });

      return menus;
    },
  },
};
</script>

<style>
.sigsenz-logo {
  background: #223640;
  width: 100%;
  bottom: 0px;
  position: absolute;
  text-align: center;
  padding: 10px;
}
.main-nav {
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
}
.mb-50 {
  margin-bottom: 50px;
}
</style>